/**
 * @license
 * Copyright 2021 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { EventActionMap } from '../util/event_action_map';
import { EnumSelectWidget } from './enum_widget';
const TOOL_INPUT_EVENT_MAP = EventActionMap.fromObject({
    'at:shift+wheel': { action: 'adjust-via-wheel' }
});
export function enumLayerControl(getter) {
    return {
        makeControl: (layer, context) => {
            const value = getter(layer);
            const control = context.registerDisposer(new EnumSelectWidget(value));
            return { control, controlElement: control.element };
        },
        activateTool: (activation, control) => {
            activation.bindInputEventMap(TOOL_INPUT_EVENT_MAP);
            activation.bindAction('adjust-via-wheel', event => {
                event.stopPropagation();
                event.preventDefault();
                control.adjustViaWheel(event.detail);
            });
        }
    };
}
//# sourceMappingURL=layer_control_enum.js.map